const TechAppDownloadIOS = () => {
  const techAppIosDownloadUrl = import.meta.env.VITE_TECH_APP_IOS_DOWNLOAD_URL || '';

  return (
    <div className="min-h-screen will-change-scroll transform-gpu">
      {/* Hero Section */}
      <div className="py-6 text-center">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Download Tech App (IOS)</h1>
          <h2 className="text-xl font-medium">
            Visit this page on your mobile device and follow the instructions below to get started
          </h2>
        </div>
      </div>

      {/* Main Content */}
      <main className="py-6 bg-gray-50">
        <section>
          <div className="container mx-auto px-4 max-w-4xl">
            {/* Step-by-step instructions */}
            <div>
              <ol className="space-y-8">
                {/* Step 1 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>1:</span>
                    <div>
                      <p className={styles.stepTextFirst}>
                        Setup your Okta username and password using the email received during onboarding and the
                        instructions found here:{' '}
                        <p className={styles.stepTextFirst}>
                          <a href="/techapp/login" className={styles.link} style={{color: '#2563eb'}}>
                            {window.location.origin}/techapp/login
                          </a>
                        </p>
                      </p>
                    </div>
                  </div>
                </li>

                {/* Step 2 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>2:</span>
                    <div className="w-full">
                      <p className="text-gray-800 mb-2">Use the button below to download the app:</p>
                      <a
                        href={techAppIosDownloadUrl}
                        className="inline-flex items-center justify-center px-4 py-2 text-base font-bold text-white bg-[#007AFF] border-2 border-[#007AFF] rounded-lg transition-all duration-200 ease-in-out hover:bg-[#006AE6] cursor-pointer active:transform-none focus:outline-none focus:ring-2 focus:ring-blue-300">
                        Download for IOS
                      </a>
                    </div>
                  </div>
                </li>

                {/* Step 3 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>3:</span>
                    <div>
                      <p className={styles.stepText}>Press the &quot;Install&quot; button</p>
                      <img
                        src="/download-tech-app-ios/install-alert.jpeg"
                        alt="IOS install alert with Install and Cancel action buttons"
                        loading="lazy"
                        decoding="async"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>

                {/* Step 4 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>4:</span>
                    <div>
                      <p className={styles.stepText}>Return to the home screen and open up the Settings app</p>
                      <img
                        src="/download-tech-app-ios/settings.jpg"
                        alt="IOS settings app"
                        loading="lazy"
                        decoding="async"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>

                {/* Step 5 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>5:</span>
                    <div>
                      <p className={styles.stepText}>In the Settings menu, tap &quot;General&quot;</p>
                      <img
                        src="/download-tech-app-ios/general-screen.jpg"
                        alt="IOS general settings screen"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>

                {/* Step 6 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>6:</span>
                    <div>
                      <p className={styles.stepText}>Scroll down and tap on &quot;VPN & Device Management&quot;</p>
                      <img
                        src="/download-tech-app-ios/vpn-device-manage-aiz.jpg"
                        alt="IOS VPN & Device Management settings"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>

                {/* Step 7 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>7:</span>
                    <div>
                      <p className={styles.stepText}>
                        Tap &quot;Assurant, Inc.&quot; and then tap &quot;Trust Assurant, Inc&quot;
                      </p>
                      <img
                        src="/download-tech-app-ios/trust-assurant.jpg"
                        alt="IOS trust Assurant certificate"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>

                {/* Step 8 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>8:</span>
                    <div>
                      <p className={styles.stepText}>
                        NOTE: This step will involve your device being restarted. Tap the &quot;Allow & Restart&quot;
                        button.
                      </p>
                      <img
                        src="/download-tech-app-ios/allow-and-restart-button.jpg"
                        alt="IOS alert with Alert & restart and Don't Allow action buttons for trusting Assurant certificate"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>

                {/* Step 9 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>9:</span>
                    <div>
                      <p className={styles.stepTextMedium}>
                        Once your device is restarted, you will be presented with a screen titled &quot;Ready to Install
                        Profile&quot;. Please follow the instructions at the bottom of the screen to continue.
                      </p>
                      <p className={styles.stepTextMedium}>
                        For example, devices with a home button will be presented with the instruction &quot;Press Home
                        to Continue&quot;.
                      </p>
                      <img
                        src="/download-tech-app-ios/ready-to-install-profile-screen.jpg"
                        alt="IOS ready to install profile screen"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>

                {/* Step 10 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>10:</span>
                    <div>
                      <p className={styles.stepTextMedium}>
                        Tap on the &quot;Install Profile&quot; button to install the &quot;Assurant, Inc.&quot; profile
                        on your device.
                      </p>
                      <img
                        src="/download-tech-app-ios/install-profile-button.jpg"
                        alt="IOS install profile button"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>

                {/* Step 11 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>11:</span>
                    <div>
                      <p className={styles.stepTextMedium}>
                        Once the profile is installed successfully, your device will be restarted back to your lock
                        screen.
                      </p>
                      <img
                        src="/download-tech-app-ios/assurant-profile-installed.jpg"
                        alt="IOS Assurant profile installed screen"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>

                {/* Step 12 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>12:</span>
                    <div>
                      <p className={styles.stepTextMedium}>
                        You&apos;re all set! Open the Fixt Partner app and start accepting repairs!
                      </p>
                      <img
                        src="/download-tech-app-ios/fixt-app-installed.jpg"
                        alt="IOS home screen with Fixt app installed"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

const styles = {
  stepNumber: 'flex items-start justify-center font-bold mr-4 mt-0',
  stepContainer: '',
  stepContent: 'flex items-start',
  stepText: 'text-gray-900 mb-4',
  stepTextMedium: 'text-gray-900 mb-4 font-medium',
  stepTextFirst: 'text-gray-800 leading-relaxed',
  linkButton: 'py-3 px-6 rounded-lg',
  link: 'font-bold underline',
  image: 'w-56 max-w-full rounded border shadow-sm',
};

export default TechAppDownloadIOS;
